<script>
import MemberBanner from '@components/MemberBanner'
import { merchantComputed, authComputed } from '@state/helpers'


export default {
  components: { MemberBanner },
  computed: {
    ...merchantComputed,
    ...authComputed
  },
}

</script>

<template>
  <div class="booking-container">
    <!--<div style="margin: 30px 0 15px">
      <router-link
        v-if="!!currentMerchant"
        class="is-link-grey"
        :to="{ name: 'booking', params: { merchantAlias: currentMerchant.alias } }"
      >
        <span class="circle-icon-style file-icon">
          <BaseIcon name="angle-left"/>
        </span>
        <span class="is-size-6">返回 | {{ currentMerchant.name }}</span>
      </router-link>
    </div>-->
    <MemberBanner :member="currentMember"/>
    <slot></slot>
  </div>
</template>
